import { css } from 'linaria';
import fonts from 'style/fonts';
export const slide = "s3dhj45";
export const title = "t1p1kjnx";
export const link = "l5aksjl";
export const wrapper = "w1oc2lo1";
export const canvas = "c1088ily";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/home-slide/styles.linaria.css");